/**
 * Utility functions for offer description functionality
 */

const MAX_OFFER_DESCRIPTION_POSITION = 3

/**
 * Determines if a description should be shown for an offer based on position and loading state
 * @param position - The position of the offer in the list (0-based)
 * @param descriptionLoading - Whether descriptions are being loaded (from socket event)
 * @returns true if description should be shown
 */
export function shouldShowOfferDescription(
  position: number | undefined,
  descriptionLoading?: boolean,
): boolean {
  return !!(
    descriptionLoading &&
    position !== undefined &&
    position < MAX_OFFER_DESCRIPTION_POSITION
  )
}
